export async function loadCatalogue({ fetchImpl = globalThis.fetch } = {}) {
  const response = await fetchImpl("/catalog.json", {
    headers: { Accept: "application/json" },
  });
  if (!response.ok) throw new Error("Catalogue could not be loaded");
  const records = await response.json();
  if (!Array.isArray(records) || records.some((record) => !record?.code || !record?.name)) {
    throw new Error("Catalogue response is invalid");
  }
  return records;
}

export function indexCatalogue(records) {
  return new Map(records.map((record) => [record.code, record]));
}

function outturnTitle(key) {
  const match = /^(\d{4})-(\d{2})$/.exec(key);
  if (!match) return key || "Unknown Outturn";
  const date = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, 1));
  return `${date.toLocaleString("en-GB", { month: "short", timeZone: "UTC" })} ${match[1]} Outturn`;
}

export function groupBrowseRecords(records) {
  const groups = new Map();
  for (const record of records) {
    const key = record.outturn || "Unknown Outturn";
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(record);
  }
  return [...groups].map(([key, grouped]) => ({
    key,
    title: outturnTitle(key),
    records: grouped,
  }));
}
